import React, { useRef, useEffect, useState } from "react";

import { Link } from 'react-router-dom';
import AuthService from "../services/auth.service";
import { useNavigate } from "react-router-dom";
import { useHistory } from 'react-router-dom';


import InputBox from "../components/InputBox";
import { Outlet } from "react-router-dom";
import logo from "../assets/img/logo.jpg";


import axios2 from 'services/axios2';
//--- CONTEXT API -----------
import { useStore, useDispatch } from "store/StoreProvider";
import { types } from "store/StoreReducer";


// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
 //---------------- CONTEXT API ------------------
    const store = useStore();
    const dispatch = useDispatch();

    const {user, products} = store;

    const [modalShow, setModalShow] = useState(false);
    const [input, setInput] = useState("");

    const [modalShow1, setModalShow1] = useState(false);
    const [input1, setInput1] = useState("");
    const [form, setForm] = useState({}); //formulario

    const navigate = useNavigate();
    
    //--------------para el timer---
    const [expirationDate, setExpirationDate] = useState("");
    let timer = useRef(null);
    let i=0;
    //------------------------------ 
    useEffect(() => {
      console.log("I have been mounted")
      cargar_form()
    }, [])
    //-----------------------------------------
    const cargar_form = () => {      

      let param = { 
        idd: 1,
        ope:'f'
      }
      console.log(param);
      axios2.post( "layout_web_cargar_globalx", param)
      .then(res => {
          console.log(res.data )
          if( res.data!==''){ 
              //añadimos el id y ope
              setForm(res.data)
              
          }else{
              //toast.error("Registro no encontrado", {
              //position: toast.POSITION.TOP_RIGHT
              //});
          }

      })
      .catch(error => {
          alert("---- Existio un error ---");
          console.log(error);
      });
    };
    //-----------------------------------
    const logout=(e)=>{
        e.preventDefault();
        //console.log("aqui estoy");
        AuthService.logout();
        navigate("/login");
        //let history = useHistory();
        //history.push("/login");
    }
    //---------- NUEVO ------------------
    //----------------INPUTBOX EDITAR (1) ---------------------
    const editar=(e)=>{
        e.preventDefault();
        setModalShow1(true);
    }
    const handleOK1=()=>{ 
        setModalShow1(false);  
        
        let fileURL = "/certificado1/"+ input1+"/e";
        //navigate(fileURL);
        window.location= fileURL;
    }
    const handleCancel1=()=>{ setModalShow1(false);   }
    const handleChange1=(e)=>{setInput1(e.target.value);  }
    //------------------INPUTBOX--REIMPRIME () ------------------------
    const reimprimir=(e)=>{
        e.preventDefault();
        setModalShow(true);
    }
    
    const handleOK=()=>{ 
        setModalShow(false);   
        let fileURL = process.env.REACT_APP_API_URL + "certificado_reciboPDF/"+ input;
        let  windowFeatures = 'width=650,height= 700, left=100,top=100 ';
        window.open(fileURL,'',windowFeatures);
    }
    const handleCancel=()=>{ setModalShow(false);   }
    const handleChange=(e)=>{setInput(e.target.value);  }
    //-----------------------------------------------------------
    return (
      <div>
        {/*<!-- Main content -->*/}
        <div className="row">
          {
            //JSON.stringify(form)
          }
          <div className="col-md-12">
            <nav className="navbar navbar-expand-lg navbar-dark bg-dark navbar-layoutit" 
                style={{overflow: 'auto'}}>
              <div className="navbar-header" style={{width: 500, display: 'flex'}}>
                

                <Link to="/" className="navbar-brand" >
                  <img src={ logo } alt="Footer Logo" height="40x"/>
                  
                </Link>
                <Link to="/login" className=" btn btn-warning" style={{ color: 'black' }}>
                    <i className="fa fa-key"></i><span> Login </span>
                </Link>
                &nbsp;
                &nbsp;
                { form.btn_preins_sn===1 &&
                  <Link to="/estudiante_preins" className="btn btn-info btn-large" >
                    <i className="fa fa-clock-o"></i><span> Pre-Inscripción </span>
                  </Link>                
                }
                &nbsp;
                &nbsp;
                { form.btn_asis_sn===1 &&
                <Link to="/control_asistencia" className="btn" role="button" style={{ backgroundColor: '#d84f64', borderColor: '#bd4a5d', color: 'white'}}>
                  <i className="fa fa-clock-o"></i><span> Registrar Asistencia </span>
                </Link>
                }
              </div>

            </nav>
          </div>
        </div>
        {/** */}
        {/* <!-- /.content-header --> */}
        <div className="containerxx">
          {/*<!--Contenido-->*/}
          <Outlet />
        </div>
      

      </div>
    )
}